import { Component, OnInit, Renderer2, Inject, Input } from '@angular/core';
import { DOCUMENT } from '@angular/common';


declare function drawRegionsMap(): any;
declare function setMapData(data): any;


@Component({
  selector: 'app-map-chart',
  templateUrl: './map-chart.component.html',
  styleUrls: ['./map-chart.component.css']
})
export class MapChartComponent implements OnInit {

  constructor(private _renderer2: Renderer2, @Inject(DOCUMENT) private _document: Document) { }

  ngOnInit() {
    this.createScript();
  }


  @Input()
  label = "Valor"

  @Input()
  set datos(value){
    this._datos = value;
    
    if(this.loaded) this.updateMap();
  }

  get datos(){
    return this._datos;
  }

  _datos = [];

  loaded = false;

  createScript(){
    let script2 = this._renderer2.createElement('script');
    script2.type ="text/javascript";
    script2.src="https://www.gstatic.com/charts/loader.js";
    script2.text = ``;
    this._renderer2.appendChild(this._document.body, script2);


    setTimeout(() => {
      let script = this._renderer2.createElement('script');
      script.type = `text/javascript`;
      script.src="../assets/scripts/map-chart.js";
      script.text = ``;
      this._renderer2.appendChild(this._document.body, script);  

      setTimeout(() => {
        this.loaded = true;
      }, 2000);
    }, 1000);
    
    
  }

  
  updateMap(){

    var ar = [
      ['Country',   this.label],
      ['Salta', 0],
      ['Buenos Aires', 0],
      ['Jujuy', 0],
      ['Córdoba', 0],
      ['Misiones', 0],
      ['Entre Ríos', 0],
      ['Corrientes', 0],
      ['Santa Cruz', 0],
      ['Chubut', 0],
      ['Río Negro', 0],
      ['La Pampa', 0],
      ['San Luis', 0],
      ['Tucumán', 0],
      ['Santa Fe', 0],
      ['Chaco', 0],
      ['Formosa', 0],
      ['La Rioja', 0],
      ['San Juan', 0],
      ['Neuquén', 0],
      ['Tierra del Fuego', 0],
      ['Catamarca', 0],
      ['Mendoza', 0],
      ['Santiago del Estero', 0],
      ['Ciudad Autónoma de Buenos Aires', 0],
    ];

    let firstDone = false;
    for(let i = 0; i<ar.length;i++){
      if(!firstDone){
        firstDone = true;
        continue;
      } 
      let count = 0;
      if(ar[i][0]=='Buenos Aires') count = this._datos.filter(x=> x.provincia == ar[i][0] || x.provincia=="Capital Federal").length;
      else count = this._datos.filter(x=> x.provincia == this.fixProvincias(ar[i][0])).length;
      ar[i][1] = count;
    }
    setMapData(ar);
    drawRegionsMap();
  }


  fixProvincias(prov){
    return prov.replace("ó", "o").replace("í", "i").replace("á", "a").replace("é","e");
  }

}
